export const personalSidebarWidth = locale => locale === "en-US" ? 280 : 190;

/**
 * 语言切换先让Vue一次性提交最终布局，再用FLIP位移和菜单裁切衔接旧画面。
 * 不逐帧改width/left/margin，不缩放文字；缩放仅作用于空白背景层。
 */
export function createPersonalSidebarMotion({ elements, reducedMotion = () => false }) {
  let revision = 0, pending = null, animations = [];
  const stop = () => {
    animations.forEach(animation => animation.cancel());
    animations = [];
  };
  const read = () => {
    const nodes = elements();
    if (!nodes.sidebar || !nodes.surface || !nodes.content) return null;
    const sidebar = nodes.sidebar.getBoundingClientRect();
    const surface = nodes.surface.getBoundingClientRect();
    const content = nodes.content.getBoundingClientRect();
    return { nodes, left: sidebar.left, width: surface.width, contentLeft: content.left };
  };
  return {
    capture() {
      // 快速反向切换从当前视觉位置接续，而不是从上一轮的目标尺寸重新起跳。
      const previous = reducedMotion() ? null : read();
      stop();
      pending = previous;
      return ++revision;
    },
    commit(token) {
      if (token !== revision || !pending) return;
      const previous = pending;
      pending = null;
      const next = read();
      if (!next || reducedMotion() || previous.width <= 0 || next.width <= 0) return;
      if (Math.abs(previous.left - next.left) < .5 && Math.abs(previous.width - next.width) < .5
        && Math.abs(previous.contentLeft - next.contentLeft) < .5) return;
      const options = { duration: 220, easing: "cubic-bezier(.2,.8,.2,1)" };
      const play = (element, keyframes) => {
        const animation = element?.animate?.(keyframes, options);
        if (animation) animations.push(animation);
      };
      try {
        play(next.nodes.sidebar, [{ transform: `translateX(${previous.left - next.left}px)` }, { transform: "none" }]);
        play(next.nodes.surface, [{ transform: `scaleX(${previous.width / next.width})` }, { transform: "scaleX(1)" }]);
        if (next.width > previous.width) play(next.nodes.menu, [
          { clipPath: `inset(0 ${next.width - previous.width}px 0 0)` }, { clipPath: "inset(0 0px 0 0)" },
        ]);
        if (Math.abs(previous.contentLeft - next.contentLeft) >= .5) play(next.nodes.content, [
          { transform: `translateX(${previous.contentLeft - next.contentLeft}px)` }, { transform: "none" },
        ]);
        const running = animations.slice();
        Promise.all(running.map(animation => animation.finished)).then(() => {
          if (token === revision) { running.forEach(animation => animation.cancel()); animations = []; }
        }).catch(() => {});
      } catch (_) { stop(); }
    },
    dispose() { revision++; pending = null; stop(); },
  };
}
